import React from 'react';
import { Mail, Clock, CheckSquare, Slack, X } from 'lucide-react';
interface AddStepMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectStepType: (type: string) => void;
}
const AddStepMenu: React.FC<AddStepMenuProps> = ({
  isOpen,
  onClose,
  onSelectStepType
}) => {
  if (!isOpen) return null;
  const stepTypes = [{
    type: 'email',
    icon: <Mail size={20} className="text-blue-500" data-id="element-71" />,
    title: 'Email',
    description: 'Send an automated email to contacts'
  }, {
    type: 'wait',
    icon: <Clock size={20} className="text-gray-500" data-id="element-72" />,
    title: 'Wait',
    description: 'Pause the sequence for a specific period'
  }, {
    type: 'task',
    icon: <CheckSquare size={20} className="text-purple-500" data-id="element-73" />,
    title: 'Task',
    description: 'Create a task in HubSpot for team members'
  }, {
    type: 'slack',
    icon: <Slack size={20} className="text-[#4A154B]" data-id="element-74" />,
    title: 'Slack',
    description: 'Send a notification to a Slack channel'
  }];
  return <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-75">
      <div className="bg-white rounded-lg w-full max-w-md" data-id="element-76">
        <div className="flex justify-between items-center p-4 border-b" data-id="element-77">
          <h2 className="text-lg font-medium" data-id="element-78">Add Step</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full" data-id="element-79">
            <X size={18} data-id="element-80" />
          </button>
        </div>
        <div className="p-4" data-id="element-81">
          <div className="space-y-2" data-id="element-82">
            {stepTypes.map(stepType => <div key={stepType.type} className="flex items-center p-3 border rounded-md cursor-pointer hover:bg-gray-50" onClick={() => {
            onSelectStepType(stepType.type);
            onClose();
          }} data-id="element-83">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full mr-4" data-id="element-84">
                  {stepType.icon}
                </div>
                <div data-id="element-85">
                  <p className="font-medium" data-id="element-86">{stepType.title}</p>
                  <p className="text-sm text-gray-600" data-id="element-87">
                    {stepType.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default AddStepMenu;